import React, { useEffect, useState } from 'react';
import { LiveStream as LiveStreamCommon } from '@bizzabo/broadcast';
import FeatureToggleUtils from 'FeatureToggleUtils';

export const LiveStream = (
    {
        virtualSessionDetails,
        isIframeLoading,
        setIsIframeLoading,
        isMobileApp
    }
) => {
    const wrapperStyle = {
        display: 'flex',
        flexDirection: 'row',
        alignContent: 'stretch',
        background: 'white'
    };
    const isLiveStreamCommonEnabled = FeatureToggleUtils.isFeatureEnabled('broadcastPlayerLiveStream');

    if (isLiveStreamCommonEnabled) {
        return isMobileApp ?
            <LiveStreamCommon
                streamId={virtualSessionDetails.streamId}
                chatEnabled={virtualSessionDetails.chatEnabled}
                iframeStyle={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}}
            />
            :
            <div className="livestream-wrapper" style={wrapperStyle}>
                {isIframeLoading && <i className="iframe-broadcast-spinner fa fa-spinner fa-spin fa-2x"/>}
                <LiveStreamCommon
                    streamId={virtualSessionDetails.streamId}
                    chatEnabled={virtualSessionDetails.chatEnabled}
                    iframeStyle={{width: '100%'}}
                    width="360"
                    height="540"
                    onLoad={() => setIsIframeLoading(false)}
                />
            </div>;
    }
    const [iframeId] = useState(`ls_embed_${Date.now()}`);

    useEffect(() => {
        const script = document.createElement('script');

        script.src = 'https://livestream.com/assets/plugins/referrer_tracking.js';
        script.setAttribute('data-embed_id', iframeId);
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const { chatEnabled, streamId } = virtualSessionDetails;
    const splitForAccountAndEvent = streamId?.split('accounts/')[1]?.split('/') ?? [];
    const accountId = splitForAccountAndEvent[0];
    const eventId = splitForAccountAndEvent[2];

    const dimensions = isMobileApp ?
        '' :
        'width=360&height=540&';

    const iframeSRC = `https://livestream.com/accounts/${accountId}/events/${eventId}/player?${dimensions}enableInfoAndActivity=${chatEnabled}&defaultDrawer=&autoPlay=true&mute=false`;

    return isMobileApp ?
        (
            <iframe
                id={iframeId}
                src={iframeSRC}
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                frameBorder="0"
                scrolling="no"
                allowFullScreen
                allow="autoplay; encrypted-media"
            />
        ) :
        (
            <div className="livestream-wrapper" style={wrapperStyle}>
                {isIframeLoading && <i className="iframe-broadcast-spinner fa fa-spinner fa-spin fa-2x"/>}
                <iframe
                    id={iframeId}
                    src={iframeSRC}
                    style={{ width: '100%' }}
                    width="360"
                    height="540"
                    frameBorder="0"
                    scrolling="no"
                    allowFullScreen
                    onLoad={() => setIsIframeLoading(false)}
                    allow="autoplay; encrypted-media"
                />
            </div>
        );
};
